'use es6';

import { UNIVERSAL_APP_IS_READY } from 'ContentEditorUI/redux/actions/actionTypes';
export const universalAppIsReady = () => ({
  type: UNIVERSAL_APP_IS_READY
});